export const DATE = 'Mon  7 Apr 2025 18:18:17 CEST';
